import { selector, useRecoilValue } from 'recoil';
import axios from 'axios';


type UserApiResponse = {
    user: {
        id: string;
        facebook_name: string;
        facebook_user_id: string;
        short_id: string | null;
        icon_path: string;
    };
    isOwner: boolean;
    hasSpot: boolean;
    isCorpUser: boolean;
    isStaff: boolean;
};


const userState = selector({
    key: "userInformation",
    get: async () => {
        try {
            const { data } = await axios.get<UserApiResponse>(
                `${window.location.origin}/api/map/signin`,
            );
            if (!data.user) {
                return {
                    isOwner: false,
                };
            };
            return {
                hasSpot: data.hasSpot,
                isOwner: data.isOwner,
                isCorpUser: data.isCorpUser,
                isStaff: data.isStaff,
                facebookName: data.user.facebook_name,
                id: data.user.id,
                facebookId: data.user.facebook_user_id,
                shortId: data.user.short_id,
                icon_path: data.user.icon_path,
            };
        } catch (e) {
            throw e;
        };
    },
});


export function useUser() {
    return useRecoilValue(userState);
};
